import { render, staticRenderFns } from "./UpdateW3Channel.vue?vue&type=template&id=ea3a5cc8&scoped=true"
import script from "./UpdateW3Channel.vue?vue&type=script&lang=js"
export * from "./UpdateW3Channel.vue?vue&type=script&lang=js"
import style0 from "./UpdateW3Channel.vue?vue&type=style&index=0&id=ea3a5cc8&prod&lang=scss&scoped=true"
import style1 from "./UpdateW3Channel.vue?vue&type=style&index=1&id=ea3a5cc8&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "ea3a5cc8",
  null
  
)

export default component.exports